import { LineString } from "geojson";
import { LatLngBounds, latLng, latLngBounds } from "leaflet";

import { ThreediModel } from "@nens/threedi/openapi-client";

export const WORLD_EXTENT = latLngBounds(latLng(-90, -180), latLng(90, 180));

export function extentToLeaflet(extent: LineString | null | undefined) {
  if (extent) {
    return latLngBounds(
      [extent.coordinates[0][1], extent.coordinates[0][0]],
      [extent.coordinates[1][1], extent.coordinates[1][0]]
    );
  } else {
    return null;
  }
}

export function combineExtents(extents: (LatLngBounds | null | undefined)[]): LatLngBounds {
  const actualExtents = extents.filter((extent): extent is LatLngBounds => !!extent);

  if (actualExtents.length === 0) {
    return WORLD_EXTENT;
  }

  const extent = actualExtents[0];

  for (let i = 1; i < actualExtents.length; i++) {
    extent.extend(actualExtents[i]);
  }

  return extent;
}

export function threediModelExtent(threediModel: ThreediModel) {
  return combineExtents([
    extentToLeaflet(threediModel.extentZeroD as unknown as LineString | null | undefined),
    extentToLeaflet(threediModel.extentOneD as unknown as LineString | null | undefined),
    extentToLeaflet(threediModel.extentTwoD as unknown as LineString | null | undefined),
  ]);
}
